<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('schedules')">Schedules</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.source }}
    </h1>
    <trashed-message v-if="schedule.deleted_at" class="mb-6" @restore="restore">
      This schedule has been deleted.
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input v-model="form.source" :error="form.errors.source" class="pr-6 pb-8 w-full lg:w-1/2" label="Source">
            <option v-for="tag in tags" :key="tag" :value="tag">{{ tag }}</option>
          </select-input>
          <select-input v-model="form.frequency" :error="form.errors.frequency" class="pr-6 pb-8 w-full lg:w-1/2" label="Frequency">
            <option v-for="frequency in frequencies" :key="frequency" :value="frequency.toLowerCase()">{{ frequency }}</option>
          </select-input>

          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-1/2" label="Email" />
          <select-input v-model="form.format" :error="form.errors.format" class="pr-6 pb-8 w-full lg:w-1/2" label="Format">
            <option v-for="format in formats" :key="format" :value="format.toLowerCase()">{{ format }}</option>
          </select-input>
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label class="form-label" for="input-start-date">Start On</label>
            <date-picker 
              class="w-full"
              input-class="form-input"
              :disabled-date="disabledDate"
              :input-attr="{id:'input-start-date'}"
              v-model="form.start_on" valueType="format">
            </date-picker>
            <div v-if="form.errors.start_on" class="form-error">{{ form.errors.start_on }}</div>
          </div>
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label class="form-label" for="input-end-date">End On</label>
            <date-picker 
              class="w-full"
              input-class="form-input"
              :disabled-date="disabledDate"
              :input-attr="{id:'input-end-date'}"
              v-model="form.end_on" valueType="format">
            </date-picker>
            <div v-if="form.errors.end_on" class="form-error">{{ form.errors.end_on }}</div>
          </div>          
          <select-input v-model="form.send_at" :error="form.errors.send_at" class="pr-6 pb-8 w-full lg:w-1/2" label="Send At">
            <option v-for="time in times" :key="time" :value="time">{{ time }}</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!schedule.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Schedule</button>
          <loading-button :loading="form.processing" class="btn-blue ml-auto" type="submit">Update Schedule</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import NProgress from 'nprogress'
import { Inertia } from '@inertiajs/inertia'

import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';


export default {
  metaInfo() {
    return {
      title: `Schedule: ${this.form.source}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    DatePicker,
  },
  layout: Layout,
  props: {
    schedule: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        source: this.schedule.source,
        frequency: this.schedule.frequency,
        email: this.schedule.email,
        format: this.schedule.format,
        start_on: this.schedule.start_on,
        end_on: this.schedule.end_on,
        send_at: this.schedule.send_at
      }),
      tags: null,

      formats: [
        'CSV',
        'Excel'
      ],
      frequencies: [
        'Daily',
        'Every Second Day',
        'Weekly',
        'Every Second Week',
        'Monthly'
      ],

    }
  },
  computed :{
    times() {
      let times = []
      for (let hour = 0; hour < 24; hour++) {
        times.push((hour + "").padStart(2, "0")+":00")
        times.push((hour + "").padStart(2, "0")+":30")
      }
      return times
    }
  },
  async created(){
    let done = false
    Inertia.on('finish', (event) => {
      if(!done){
        NProgress.start()
      }
    })
		const [postrostaConfig, postrostConfig, postrostaV2Config] = await Promise.all([
			axios.get('https://sheets.web-services.verified.eu/postrosta/config'),
      axios.get('https://sheets.web-services.verified.eu/postrost/config'),
      axios.get('https://sheets.web-services.verified.eu/postrosta-v2/config')
		])
    this.tags = [...new Set([...Object.keys(postrostaConfig.data.token), ...Object.keys(postrostConfig.data.token), ...Object.keys(postrostaV2Config.data.token)])]
    done = true
    if(NProgress.isStarted()){
        NProgress.done()
    }
  },  
  methods: {
    update() {
      this.form.put(this.route('schedules.update', this.schedule.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this schedule?')) {
        this.$inertia.delete(this.route('schedules.destroy', this.schedule.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this schedule?')) {
        this.$inertia.put(this.route('schedules.restore', this.schedule.id))
      }
    },
    disabledDate(date, current){
      let today = new Date()      
      return date.setHours(16) < today
    }    
  },
}
</script>
